import { render, staticRenderFns } from "./onDialogOpened-editor.vue?vue&type=template&id=149fcc24&scoped=true&"
import script from "./onDialogOpened-editor.vue?vue&type=script&lang=js&"
export * from "./onDialogOpened-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149fcc24",
  null
  
)

export default component.exports